
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[communitySlug]/detail",
      function () {
        return require("private-next-pages/community/[communitySlug]/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[communitySlug]/detail"])
      });
    }
  